import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MaterialModule } from "../../material-module";
import { LocalStorageService } from "../../services/local-storage.service";

@Component({
    selector: "app-translator-dropdown",
    standalone: true,
    imports: [CommonModule, MaterialModule],
    templateUrl: "./translator-dropdown.component.html",
    styleUrls: ["./translator-dropdown.component.scss"],
})
export class TranslatorDropdownComponent implements OnInit {
    selectedLanguage = "";

    constructor(
        private translate: TranslateService,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit(): void {
        if (this.localStorageService.getLocale()) {
            this.translate.use(this.localStorageService.getLocale());
            this.selectedLanguage = this.localStorageService.getLocale();
        } else {
            const browserLang = this.translate.getBrowserLang();
            this.selectedLanguage = browserLang;
            this.translate.use(browserLang);
        }
    }

    onSwitch(lang: string): void {
        this.translate.use(lang);
        this.selectedLanguage = lang;
        this.localStorageService.setLocale(lang);
    }
}
